module.exports = __webpack_public_path__ + "37edc1717175d2721c47f298270b6f1a.svg";